import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSupplierDetail = createAsyncThunk("fetchSupplierDetail", async ({id}) => {
	const response = await axiosHttp.get(`${MEAL_BASE_URL}supplier/${id}`);
	return response.data.data;
});

const SupplierDetailSlice = createSlice({
	name: "SupplierDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSupplierDetail.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSupplierDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchSupplierDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SupplierDetailSlice.reducer;
